module.exports = "<div class=\"bottom-copyright\">\r\n    {{'general.copyright' | translate: param}}\r\n</div>"